
import { Component, Prop } from 'nuxt-property-decorator';
import HeaderUtils from '@/components/ui/HeaderUtils.vue';
import ReadAloudStore from '@/components/ui/read-aloud/library/read-aloud.store';
import { PageContentInfo } from '@/types/initialData';
import { pushEvent } from '@/util/grafana-faro';

@Component({
  components: {}
})
export default class SiteMapLinkUtils extends HeaderUtils {
  @Prop({ type: String, default: '' })
  tocLink!: string;

  @Prop({ type: Number, default: null })
  cId!: number;

  get tocLinkUid() {
    return this.$attrs.tocuid;
  }

  initReadAloud(): void {
    const range = document.createRange();
    // referenceNode is the a-tag in question
    const referenceNode = this.$parent.$el.querySelector('.d-flex');
    range.selectNodeContents(referenceNode);
    ReadAloudStore.notifyReadAloud(range);
    ReadAloudStore.playerShowing = true;
    this.closeContextMenu();
    document.getSelection().removeAllRanges();
    pushEvent('Polly', {
      value: 'Play',
      type: 'SiteMapLink',
      component: 'SiteMapLinkUtils'
    });
  }

  showPageDetails(): void {
    this.pageDetailsActive = true;
  }

  get pageDetails() {
    return this.$attrs.info as PageContentInfo;
  }
}
